<template>
	<div
		class="star-indicator"
		:class="{ 'selected': selected }"
	>
		<font-awesome-icon :icon="['fas', 'star']" fixed-width v-if="selected" />
		<font-awesome-icon :icon="['far', 'star']" fixed-width v-else />
	</div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';

import { faStar } from '@fortawesome/pro-regular-svg-icons';
import { faStar as faSolidStar } from '@fortawesome/pro-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faStar, faSolidStar);

@Component
export default class StarIndicator extends Vue {
	@Prop({ default: false, type: Boolean })
	selected: boolean;
}
</script>

<style lang="scss">
.star-indicator {
	@apply inline-flex flex-row items-center justify-center cursor-pointer rounded-full bg-fill text-border-gray;

	&:focus {
		@apply text-fill-accent;
		transform: scale(1.2);
		outline: none;
	}

	font-size: 28px;
	width: 28px;
	height: 28px;

	transition: color 400ms linear, scale 300ms ease-in;

	&.selected {
		@apply text-fill-accent;

		&:focus {
			transform: scale(1.2);
		}
	}
}
</style>
